import React from 'react';
import './App.css';
import RouterComponent from './router/app';
import { config } from '@/lib/config';

class App extends React.Component {
  public render() {
    return (
      <RouterComponent/>
    );
  }
}

export default App;

<script src={ `https://www.recaptcha.net/recaptcha/api.js?render=${config().platformCode}` }></script>
